import React, { useEffect, useState } from 'react'
import { Modal } from 'antd'
import './AddCreditCard.css'
import Iframe from 'react-iframe'

export default function AddCreditCard({
  isOpen,
  setIsOpen,
  addCardData,
  setIsRefresh
}) {

  useEffect(() => {

    const interval = setInterval(() => {
      try {
        const iframe = document.getElementById('payment-iframe')
        const iframeWindow = iframe?.contentWindow
        const currentUrl = iframeWindow?.location.href

        console.log('iframe URL:', currentUrl)

        if (currentUrl?.includes('/callback')) {
          console.log('callback')
          // 在这里处理订单确认逻辑，比如调用后端接口
          // 关闭支付页面
          setIsRefresh(true)
          setIsOpen(false)
          clearInterval(interval)
        }
      } catch (err) {
        // 跨域时会抛出异常，这里捕获即可
        console.warn('cannot get iframe URL (cross-origin)', err)
      }
    }, 1000) // 每秒检查一次

    return () => clearInterval(interval)
  }, [])

  return (
    <Modal
      // title="Get the app"
      open={isOpen}
      onCancel={() => {
        setIsRefresh(true)
        setIsOpen(false)
      }}
      footer={null}
      forceRender
      destroyOnClose={false}
      width={600}
      zIndex={99999}
    >
      <div>
        <div>
          <h3 className='text-[20px] font-medium'>Add a credit or debit card</h3>
        </div>
        {/* {addCardData?.hosted_payment_uri && ( */}
        <Iframe
          id='payment-iframe'
          width='100%'
          height='450px'
          url={addCardData?.hosted_payment_uri}
          className='rounded-lg'
        />
        {/* )} */}
      </div>
    </Modal>
  )
}
